module.exports = __webpack_public_path__ + "img/bg-hotel.0f5fb8ef.jpg";